<template>
  <section v-if="getMessages">
    <div class="body">
      <chat-mensagem
        class="chatMensagem"
      ></chat-mensagem>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import ChatMensagem from "../mensagem/ChatMensagem";

export default {
  components: {
    ChatMensagem,
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters([
      "getMessages",
    ]),
  },
  methods: {},
};
</script>

<style scoped>
.body {
  /* height: calc(100vh - 10.5em);  */
  display: flex;
  align-items: stretch;
}
.chatMensagem {
  display: flex;
  flex: 1;
  max-height: 81vh;
  min-height: 81vh;
}

@media screen and (max-width: 1489px) {
  .body {
    height: calc(100vh - 14.3em);
  }
}
@media screen and (max-width: 941px) {
  .body {
    height: calc(100vh - 19.1em);
  }
}
</style>
